<template>
  <div class="app">
    <div class="m-viewport" id="mainView">

        <div class="cover">
            <video src="https://web-resource.17m3.com/m3guo/202511/jnh-ver/cover.mp4?v=1.01" autoplay loop></video>
        </div>

        <div class="logo-view">
          <h2 class="logo_1"><a href="https://www.m3guo.com/v2/" target="_blank" rel="noopener noreferrer"></a></h2>
          <!-- <h2 class="logo_2"><a href="https://www.m3guo.com/activity/202509/v-yyds/" target="_blank" rel="noopener noreferrer"></a></h2> -->
        </div>
        
        <div class="u-links">
            <div class="btn-index icon sprite-btn-web">
                <a href="https://www.m3guo.com/v2/" target="_blank" rel="noopener noreferrer"></a>
            </div>
            <div class="btn-dl icon sprite-btn-dl">
              <a href="https://www.m3guo.com/v2/download/client/" target="_blank" rel="noopener noreferrer"></a>
            </div>
        </div>
        
        <div class="u-btn copyright">
            <!-- todo -->
        </div>



        <div class="u-btn invite icon sprite-btn-share" @click="call_invite()"></div>

        <div class="side-nav">
            <div class="header"></div>
            <div class="body" :class="{'sm' : ($store.state.userinfo.uflag & 2) != 2}">
                <div class="u-btn welcome" @click="$welcome_modal()">
                    <div class="layer-star s-1"></div>
                    <div class="layer-star s-2"></div>
                </div>
                <div class="u-btn misc" @click="$misc_modal()" v-if=" ($store.state.userinfo.uflag & 2) == 2"></div>
            </div>
        </div>
        
        <loading v-show="Loading"/>
     
        <div class="page-body" v-if="ready">
            <div class="page-wrapper">
                <skins/>
                <events style="margin-top: 130px;"/>
                <update style="margin-top: 130px;"/>
                <game-map style="margin-top: 175px;"/>
                <more style="margin-top: 130px;"/>
            </div>
        </div>

        <div class="sns-view">
            <div class="sns-trriger u-btn" @mouseover="sns = true" v-show="!sns"></div>
            <div class="sns-pannel" :class="{'active' : sns}" @mouseleave="sns = false">
                <div class="sns-list flex-start-center">
                    <div class="qr-item">
                        <div class="qr-img"><img :src="require('@/assets/images/m/qr-dy.png')" alt="" srcset=""></div>
                        <div class="sns-name">-抖音-</div>
                    </div>
                    <div class="qr-item">
                        <div class="qr-img"><img :src="require('@/assets/images/m/qr-app.png')" alt="" srcset=""></div>
                        <div class="sns-name">-口袋-</div>
                    </div>
                    <div class="qr-item">
                        <div class="qr-img"><img :src="require('@/assets/images/m/qr-wx.png')" alt="" srcset=""></div>
                        <div class="sns-name">-公众号-</div>
                    </div>
                </div>                
            </div>
        </div>

    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

import {
    apiShare, 
} from '@/api/index';

export default {
    name: 'mainview',
    components: {
        loading: () => import('@/components/loading.vue'),
        skins: ()=> import('@/views/skins.vue'),
        events : ()=> import('@/views/event.vue'),
        update: ()=> import('@/views/update.vue'),
        'game-map' : ()=> import('@/views/map.vue'),
        more : ()=> import('@/views/more.vue'),
    },
    data (){
        return {
            sns : false,
        }
    },
    computed : {
        ...mapState(['Loading'])
    },    
    props : {
        ready : {
            default : false,
        },
    },
    methods : {
        call_invite(){
            if(!this.$store.state.login){
                return this.$mslogin.login();
            }
            if(!this.$store.state.userinfo.zid){
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }
            
            apiShare().then(
                res => {
                    let shareTxt = res.data.koudai  ? (res.data.koudai + res.data.url) : res.data.url; 
                    this.$invite_modal({ shareTxt : shareTxt });                   
                },
                rej => {
                    this.$toast(rej.message)
                }
            )
        },        
    }, 
}
</script>

<style lang="scss" scoped>
@keyframes play_pc {
  from { background-position: 0 0; }
  to { background-position: 0 -816px; }
}


.m-viewport{
    position: relative;
    width: 100%;
    min-width: 1200px;
    max-width: 1920px;
    // height: 8000px;
    margin: 0 auto 0;
    box-sizing: border-box;
    font-size: 16px;
    background-color: #341e0d;
    color: #dec291;
    overflow-x: hidden;
    overflow-y: hidden;
    // font-family: "HYChangLiSongKeBenJ";

    b{
        font-weight: 400;
        color: #26c7da;        
    }
}

.cover{
    position: absolute;
    left: 50%;
    top: -42px;
    width: 1920px;
    height: 1080px;
    transform: translateX(-50%);
    z-index: 5;
    overflow: hidden;
    // background-color: #000;

    video{
        width: 100%;
        height: 100%;
        object-fit: cover;
        border: none;
        mix-blend-mode: darken; 
    }
}

.u-btn.invite{
    position: fixed;
    right: 2%;
    top: 30%;
    z-index: 10;
}

.sns-view{
    position: fixed;
    right: 0;
    bottom: 200px;
    height: 318px;
    display: flex;
    align-items: center;
    z-index: 10;

    .sns-trriger{
        width: 58px;
        height: 165px;
        background-image: url(~@/assets/images/pc/sns-trriger.png);
    }

    .sns-pannel{
        position: absolute;
        right: -900px;
        top: 50%;
        transform: translateY(-50%);
        width: 748px;
        height: 318px;
        margin: 30px auto 0;
        padding-left: 108px;
        box-sizing: border-box;
        background-image: url(~@/assets/images/m/pannel-sns.png);
        transition: all 0.4s ease-in-out;

        &.active{
            right: 0;
        }

        .sns-list{
            height: 318px;
        }

        .qr-item{
            margin: 0 20px;
        }

        .sns-name{
            text-align: center;
            color: #668d78;
        }
    }    
}

.logo-view{
    display: flex;
    align-items: center;
    position: absolute;
    left: 2%;
    top:30px;
    z-index: 10;
}

.logo-view a{
    display: block;
    width: 100%;
    height: 100%;
}

.logo-view .logo_1{
    width: 147px;
    height: 123px;
    background-image: url(~@/assets/images/pc/logo.png);
}

.logo-view .logo_2{
    width: 125px;
    height: 125px;
    margin-left: 26px;
    background-image: url(~@/assets/images/pc/logo_aniver.png);
}

.u-links{
    display: flex;
    position: absolute;
    right: 4%;
    top: 30px;
    z-index: 3; 
    
    &>div{
        margin-left: 20px;
    }
}

.u-links a{
    display: block;
    width: 100%;
    height: 100%;
}

.page-body{
    position: relative;
    width: 100%;
    min-width: 1200px;
    max-width: 1920px;
    height: calc(6700px - 42px);
    padding-top: 950px;
    background-repeat: no-repeat;
    background-position: center -42px;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: hidden;
    background-image: url(~@/assets/images/pc/body.webp);   
}

.m-user{
    width: 696px;
    height: 36px;
    line-height: 36px;
    margin: 0 auto;
    text-align: center;
    //background-image: url(~@/assets/images/pc/bg-userinfo.png); 
}

.page-wrapper{
    margin: 67px auto 0;

}
</style>
